export interface UserSchema {
    // id: UUID;
    username: string;
    userRole: UserRole;
}

export enum UserRole {
    ADMIN = 1,
    PATIENT,
    CARE_PARTNER,
}

export type UserDetails = Admin | NonAdmin;

export interface Admin {
    // id: string; //uid
    username: string; //login username assigned to this User
    userRole: UserRole.ADMIN;
    firstName: string;
    lastName: string;
    institution: string;
    confirmed: boolean; //this user has completed the initial account activation process to fully establish their account
}

export interface NonAdmin {
    // id: string; //uid
    username: string; //login username assigned to this User
    userFirstName?: string;
    userRole: UserRole.PATIENT | UserRole.CARE_PARTNER;
    confirmed: boolean; //this user has completed the initial account activation process to fully establish their account
    surveyId: string; //survey assigned to pair
    // pairUserId: string;
    pairUsername: string;
    pairFirstName?: string;
    pairConfirmed: boolean;
}

export interface CreateAdminRequest {
    email: string;
    firstName: string;
    lastName: string;
    institution: string
}

export interface ViewCurrentUserResponse {
    currentUser: UserDetails
}

export interface UpdateCurrentUserRequest {
    firstName?: string;
    lastName?: string;
    institution?: string;
}



